<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.phone_list") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fas.fa-phone
                  DebounceInput(autofocus type="text" v-model="phone" :placeholder="$t('ui.phone')" @enter="getCpiOperatorPhoneList(true)" size="sm")
              .form-group.col-md-3.col-2.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.status') }}
                  b-form-select(v-model="phoneStatus" size="sm" @change="getCpiOperatorPhoneList(true)")
                    option(value="") {{ $t('ui.all') }}
                    option(value="READY") {{ $t('ui.ready') }}
                    option(value="BUSY") {{ $t('ui.busy') }}
              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getCpiOperatorPhoneList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isEditAccess")
                b-button(v-b-modal.addPhone type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_phone") }}

          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12 
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="20%")
                          span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
                        th.text-center(width="10%" @click="sortOrder('status')")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                          .float-right
                            i(:class="changeSortKey('status')")
                        th.text-right(width="12%")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        th.text-right(width="12%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                        th.text-center(width="8%" v-if="isEditAccess")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="cpiOperatorPhoneList.length == 0")
                        td(:colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in cpiOperatorPhoneList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.phone") {{ item.phone }}
                        td.text-center
                          span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          template(v-if="item.modified_date != null")
                            span(:title="item.modified_by") {{ item.modified_by }}
                            br
                            span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                          span(v-else) -
                        td.text-center(v-if="isEditAccess")
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )
    addphone(@clicked="addPhone" :operatorID="searchID" @failed="handleFailed")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addphone from "@/components/cpi/addPhone.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addphone
  },
  data: () => ({
    loading: false,
    cpiOperatorPhoneList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "",
    sortType: "",
    searchID: '',
    phone: '',
    phoneStatus: ''
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cpi");
    }
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.searchID = this.accountID
      }
      this.getCpiOperatorPhoneList(true);
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getCpiOperatorPhoneList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getCpiOperatorPhoneList: function(isSearch) {
      let url = config.cpiOperatorPhoneUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.searchID,
        phone: this.phone,
        phone_status: this.phoneStatus,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cpiOperatorPhoneList = response.data.dt;
                this.totalRow = this.cpiOperatorPhoneList.length > 0 ? this.cpiOperatorPhoneList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getCpiOperatorPhoneList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getCpiOperatorPhoneList();
    },
    onDelete:function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.delete"),
          text: this.$t("message.delete_phone_confirm", { name: e.phone }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(e);
          }
        });
    },
    confirmDelete: function(e) {
      let url = config.cpiOperatorPhoneDeleteUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        account_id: this.searchID,
        phone: e.phone
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getCpiOperatorPhoneList(true);
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status, 'cpiopdeletephone')) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addPhone: function() {
      this.getCpiOperatorPhoneList();
      this.$helpers.showDialog(this.$t("ui.combine.add_phone"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
